// Only the last four digits are shown back to the user: enough to recognise the
// number the pin will land on, without printing it in full on a shared screen.
export const maskCellphoneNumber = (cellphoneNumber: string | null): string => {
  const digits = (cellphoneNumber || '').replace(/\D/g, '')
  if (digits.length < 4) return 'your registered number'

  return `••• ••• ${digits.slice(-4)}`
}

export const backupCodesFilename = () => `wealthbit-backup-codes-${new Date().toISOString().slice(0, 10)}.txt`

// Shown in groups of four so the key can be read off the screen and typed into
// an app without losing your place. Authenticator apps ignore the spaces; the
// copy button hands over the ungrouped key regardless.
export const groupSetupKey = (secret: string): string => (secret.match(/.{1,4}/g) || []).join(' ')

export const backupCodesRemainingLabel = (count: number): string => {
  if (count === 0) return 'No backup codes left'
  if (count === 1) return '1 backup code left'

  return `${count} backup codes left`
}

// Below this, the settings page nudges the user to generate a fresh set before
// they are left with nothing to fall back on.
export const LOW_BACKUP_CODES = 3

export const isSixDigitCode = (code: string): boolean => /^\d{6}$/.test(code.replace(/\s/g, ''))
